import { Link } from "react-router-dom";
import { LegalLayout } from "../components/LegalLayout";
import { EnquiryForm } from "../components/EnquiryForm";
import { PLAN_WITH_US_PAGE } from "../data/legalPages";

const Steps = () => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-12" data-testid="plan-with-us-steps">
    {[
      ["1", "Tell us about the trip", "Destination, dates, travellers and budget — or send a generated itinerary."],
      ["2", "A human reviews it", "Every venue, hour and price checked by hand within 48 hours."],
      ["3", "Book with confidence", "Your verified plan lands in your inbox and your account."],
    ].map(([n, t, d]) => (
      <div key={n} className="p-5 rounded-2xl border border-black/5 bg-white/60">
        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#1A3B2B] text-[#FDFBF7] font-display mb-3">{n}</span>
        <p className="font-medium">{t}</p>
        <p className="text-sm text-muted-foreground mt-1">{d}</p>
      </div>
    ))}
  </div>
);

export default function PlanWithUs() {
  return (
    <LegalLayout page={PLAN_WITH_US_PAGE} testId="plan-with-us-page" showUpdated={false} before={<Steps />}>
      <p className="text-sm text-muted-foreground mb-6">
        Read the full <Link to="/refunds" className="text-[#C8553D] underline underline-offset-4" data-testid="plan-with-us-refunds-link">Refund & Cancellation Policy</Link>.
      </p>
      <EnquiryForm heading="Request your human-verified plan" />
    </LegalLayout>
  );
}
